import parseColor from './parseColor';
// This code is copypast from Thunderbolt - https://github.com/wix-private/thunderbolt/blob/1080b5b99467a53af6d63f191e905995abb02eb4/packages/thunderbolt-components/src/components/TPAWidget/tpaStyleUtils.ts#L5
// Since editorSDK get it data from documentService (where there is no reference in color), for backward compatibility we need this logic
var PRIME_COLORS_REFERENCES = [
    'white/black',
    'black/white',
    'primery-1',
    'primery-2',
    'primery-3',
];
var NON_PRIME_COLORS_PREFIX = 'color-';
var getReferenceFromName = function (name) {
    var _a = name.split('_'), colorIndex = _a[1];
    var index = Number(colorIndex);
    return index <= 5
        ? PRIME_COLORS_REFERENCES[index - 1]
        : "".concat(NON_PRIME_COLORS_PREFIX).concat(index - 10);
};
export function getWixColor(_a) {
    var colors = _a.colors, reference = _a.reference, _b = _a.opacity, opacity = _b === void 0 ? 1 : _b;
    var wixColor = colors.find(function (c) { var _a; return ((_a = c.reference) !== null && _a !== void 0 ? _a : getReferenceFromName(c.name)) === reference; }) || null;
    return {
        opacity: opacity,
        value: parseColor(wixColor === null || wixColor === void 0 ? void 0 : wixColor.value, opacity).rgb(),
        name: wixColor === null || wixColor === void 0 ? void 0 : wixColor.name,
    };
}
// Based on theme wiring in viewer, but mapping to tpa color references: https://github.com/wix-private/thunderbolt/blob/master/packages/thunderbolt-app/src/assets/scss/themeWiringVars.scss
var colorReferenceBySemanticName = {
    'color-fill-background-primary': 'color-1',
    'color-fill-background-secondary': 'color-2',
    'color-text-primary': 'color-5',
    'color-text-secondary': 'color-4',
    'color-action': 'color-8',
    'color-disabled': 'color-29',
    'color-title': 'color-35',
    'color-subtitle': 'color-36',
    'color-line': 'color-37',
    'button-color-fill-primary': 'color-38',
    'button-color-border-primary': 'color-39',
    'button-color-text-primary': 'color-40',
    'button-color-fill-primary-hover': 'color-41',
    'button-color-border-primary-hover': 'color-42',
    'button-color-text-primary-hover': 'color-43',
    'button-color-fill-primary-disabled': 'color-44',
    'button-color-border-primary-disabled': 'color-45',
    'button-color-text-primary-disabled': 'color-46',
    'button-color-fill-secondary': 'color-47',
    'button-color-border-secondary': 'color-48',
    'button-color-text-secondary': 'color-49',
    'button-color-fill-secondary-hover': 'color-50',
    'button-color-border-secondary-hover': 'color-51',
    'button-color-text-secondary-hover': 'color-52',
    'button-color-fill-secondary-disabled': 'color-53',
    'button-color-border-secondary-disabled': 'color-54',
    'button-color-text-secondary-disabled': 'color-55',
    'color-fill-base-1': 'color-26',
    'color-fill-base-2': 'color-27',
    'color-fill-base-shade-1': 'color-28',
    'color-fill-base-shade-2': 'color-29',
    'color-fill-base-shade-3': 'color-30',
    'color-fill-accent-1': 'color-31',
    'color-fill-accent-2': 'color-32',
    'color-fill-accent-3': 'color-33',
    'color-fill-accent-4': 'color-34',
    // Studio Custom Colors (7th and above)
    'color-custom-1': 'color-13',
    'color-custom-2': 'color-16',
    'color-custom-3': 'color-17',
    'color-custom-4': 'color-19',
    'color-custom-5': 'color-20',
    'color-custom-6': 'color-21',
    'color-custom-7': 'color-22',
    'color-custom-8': 'color-23',
    'color-custom-9': 'color-24',
    'color-custom-10': 'color-25',
    'color-custom-11': 'color-26',
    'color-custom-12': 'color-27',
    'color-custom-13': 'color-28',
    'color-custom-14': 'color-29',
    'color-custom-15': 'color-30',
    'color-custom-16': 'color-31',
    'color-custom-17': 'color-32',
    'color-custom-18': 'color-33',
    'color-custom-19': 'color-34',
    'color-custom-20': 'color-35',
};
export var wixColorParam = function (name, opacity) {
    return function (_a) {
        var colors = _a.colors;
        var semanticName = colorReferenceBySemanticName[name];
        return getWixColor({ reference: semanticName || name, opacity: opacity, colors: colors });
    };
};
//# sourceMappingURL=getWixColor.js.map